import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'

// Growthbook experiment: https://app.growthbook.io/features/com-1953-price-change-fe
export const PRICE_CHANGE_V2_EXPERIMENT_FLAG = 'com-1953-price-change-fe'
export const PRICE_CHANGE_V2_PARAM_NAME = 'experiment'
export const PRICE_CHANGE_V2_PARAM_VALUE_PREFIX = 'exp_v2_'

export const trackPriceChangeV2ExperimentViewed = () => {
  trackExperimentViewed(
    PRICE_CHANGE_V2_EXPERIMENT_FLAG,
    {},
    { trackUserLeap: true },
  )
}

export const usePriceChangeV2Experiment = () => {
  const bucket = useBucket(PRICE_CHANGE_V2_EXPERIMENT_FLAG)
  return bucket
}
